
import { Mixins, Prop, Component } from "vue-property-decorator";
import { mdiFormatListBulleted, mdiHeart } from "@mdi/js";
@Component({
	components: {}
})
export default class ButtonToggle extends Mixins() {
	@Prop() icon1: string = "";
	@Prop() leftText: string = "";
	@Prop() leftIcon: string = "";
	@Prop() rightText: string = "";
	@Prop() rightIcon: string = "";
	@Prop() clickedList: boolean = true;
	
	mdiFormatListBulleted = mdiFormatListBulleted;
	mdiHeart = mdiHeart;
	emit(emitted: string, info?: string): void {
		this.$emit(emitted, info);
	}
	showFavourites(): void {
		this.emit("click:fav");
	}
	showList(): void {
		this.emit("click:list");
	}
}
